<template>
  <div class="reportListData">
    <div class="item" v-for="(item,index) in listData" :key="index">
      <div class="item_label">
        <span>{{item.exam_class}} {{item.insConfig? '( ' + item.insConfig.slice(0,item.insConfig.length-1) + ' )' : ''}}</span>
        <span class="status Success">
          {{getExamStatus(item)}}
          <!-- <span
            v-if="(item.charge_mode == 1&&item.pay_status==0) || (item.charge_mode == 3&&item.pay_status==0)"
            class="status Danger"
          >(未支付)</span>-->
        </span>
      </div>
      <div class="item_content">
        <div>
          <span class="label">医院:</span>
          <span class="content">{{item.institution}}</span>
        </div>
        <div>
          <span class="label">流水号:</span>
          <span class="content">{{item.patient_num}}</span>
        </div>
        <div>
          <span class="label">姓名:</span>
          <span class="content">{{item.name}}</span>
        </div>
        <div>
          <span class="label">检查时间:</span>
          <span class="content">{{item.exam_datetime}}</span>
        </div>
        <div v-if="item.institution_id ==='06300007'">
          <span class="label">检查部位:</span>
          <span
            class="content"
            style="overflow: hidden;text-overflow: ellipsis;white-space: nowrap;flex: 1;"
          >{{item.exam_project}}</span>
        </div>
        <div v-if="item.config_number&&item.insConfig">
          <span class="label">{{item.insConfig}}:</span>
          <span class="content">{{item.config_number}}</span>
        </div>
      </div>
      <div class="item_time">
        <span v-if="item.report_interpret == '1'">
          <button class="checkButton" @click="goDoctorReportRead(item, 'fromList')" style="width: 92px;">请医生解读报告</button>
        </span>
        <div>
          <span v-if="item.institution_id == '03060002' && ((item.charge_mode == 1&&item.pay_status==0) || (item.charge_mode == 3&&item.pay_status==0))"
          >
            <button
              class="payButton"
              @click="pay(item)"
            >立即支付</button>
          </span>
          <span v-else>
            <button v-if="item.exam_status == 9" class="checkButton" @click="checkReport(item, 1)">查看</button>
            <!-- <button
              type="info"
              class="checkButton"
              @click="callReportPrint(item)"
            >报告原件</button> -->
          </span>
        </div>
        <!-- 73000005 -->
        <!--report_see 报告未写之前公众号是否能查看影像 1 可以查看  -----可以转发报告页面
         0 不可以查看 直接跳到报告列表 -->
         <div>
          <span v-if="item.institution_id == '73000005' || (item.institution_id!=='43600001'&&item.report_see==1&&item.exam_status != 9) || (item.is_dcm == '1'&&item.institution_id == '43600001')">
            <button
              class="checkButton"
              @click="checkReport(item, 2)"
            >查看影像</button>
          </span>
          
         </div>
        
        <span v-if="item.patient_send_email == '1'">
          <button class="checkButton" @click="openEmail(item)">下载到邮箱</button>
        </span>
      </div>
    </div>

    <!-- 检查详情报告解读 同意书弹窗 -->
    <van-dialog v-model="isOpenReadModel" title="三甲名医在线解读" :show-confirm-button="false">
      <van-icon name="cross" style="position: absolute;top: 15px;right: 15px;color:#909399;" @click="isOpenReadModel = false" />
      <div class="scrollBox">
        <div class="blocks">
          <p>✅支持所有检验和检查报告：核磁、CT、X线、血常规、尿常规、肾功、肝功、甲功等。</p>

          <p>✅支持咨询在线医生：饮食、运动和疾病预防等相关问题。</p>

          <p>👍专业、细致、耐心。</p>
          <!-- <div style="height:80px"></div> -->
           <div style="background: #fff;">
            <div style="margin: 10px 0;">
              <van-checkbox v-model="checked" shape="square" icon-size="12px" @change="changeHandle"/>
              <span style="margin-left:5px;color: rgb(19, 172, 193);">我已同意<span @click="goReadDetailModel()">《数字影像云报告解读服务知情同意书》</span></span>
            </div>
            <div style="width: 100%;"> 
              <!-- <button class="reportRead" @click="handleLaunch2">报告解读</button> -->
              <van-button type="primary" v-if="!checked" @click="goReportRead1">开始解读</van-button>
              <wx-open-launch-weapp
                  id="launch-btn2"
                  appid="wx13a47ee9b472614f"
                  :path="xcxurl"
                  @launch="handleLaunch2"
                  @error="handleError2"
                  v-else
                >
                  <script type="text/wxtag-template">
                    <style>
                      .reportRead1 {
                        width: 234px;
                        height: 44px;
                        padding: 5px 0;
                        border-radius: 50px;
                        color: #fff!important;
                        font-size: 16px!important;
                        border: 1px solid rgb(19, 172, 193);
                        background-color: rgb(19, 172, 193);
                      }
                    </style>
                    <button class="reportRead1">开始解读</button>
                  </script>
                </wx-open-launch-weapp>
            </div>
           </div>
           
        </div>
      </div>
    </van-dialog>
    <van-dialog v-model="isOpenReadDetailModel" title="数字影像云报告解读服务知情同意书" :show-confirm-button="false">
      <van-icon name="cross" style="position: absolute;top: 15px;right: 15px;color:#909399;" @click="isOpenReadDetailModel = false" />
      <div class="scrollDetailBox">
        <div class="blocks">
          <!-- <div>《数字影像云报告解读服务知情同意书》</div> -->
          <p>尊敬的患者/患者家属：</p>
          <p>
            您好！感谢您选择使用中世康恺科技有限公司提供的“数字影像云”公众号服务中的“报告
            解读”功能。为保障您的合法权益，确保您充分了解该服务的相关情况，特向您告知如下内
            容：
          </p>
          <p class="subTitle">一、服务内容</p>
          <p>“数字影像云”公众号服务中的“报告解读”功能由重庆君子务本科技有限公司提供。当您
点击“报告解读”按钮时，将跳转至重庆君子务本科技有限公司提供的报告解读服务页面。
该服务旨在通过专业的技术手段和医学知识，对您的医学影像报告进行解读，帮助您更好地
理解报告内容及检查结果。</p>
          <p class="subTitle">二、数据安全与隐私保护</p>
          <p>1.中世康恺科技有限公司和重庆君子务本科技有限公司均高度重视您的个人信息安全与隐
            私保护。您的影像资料及报告信息将通过加密技术进行传输与存储，确保数据的安全性。</p>
          <p>2.您的个人信息及报告解读结果仅用于为您提供医疗服务及必要的医疗咨询，不会用于其他任何商业用途。</p>
          <p>3.在服务过程中，如需将您的报告解读结果共享给其他医疗机构或专业人士，将事先征得您的明确同意。</p>
          <p class="subTitle">三、风险与限制</p>
          <p>1.报告解读服务是基于现有的医学知识和技术手段提供的辅助性解读，不能替代专业医生
            的面诊意见。最终的诊断和治疗方案应以医生的专业判断为准。</p>
            <p>2.由于医学的复杂性和个体差异，报告解读结果可能存在一定的局限性。在某些情况下，
              可能需要进一步的检查或诊断以确认病情。</p>
          <p>3.如您在使用报告解读服务过程中遇到任何问题或对解读结果有疑问，应及时咨询专业医
            生。</p>
            <p class="subTitle">四、费用说明</p>
            <p>重庆君子务本科技有限公司提供的报告解读服务可能涉及一定的费用。具体收费标准及支付
              方式将在服务页面进行明确说明。您在使用该服务前应仔细阅读相关费用说明，并确认同意
              支付相应费用。</p>
            <p class="subTitle">五、同意与授权</p>
            <p>1.您已充分了解上述内容，自愿选择使用“数字影像云”公众号服务中的“报告解读”功
能，并同意中世康恺科技有限公司将您的影像资料及报告信息传输给重庆君子务本科技有限
公司进行解读。</p>
          <p>2.您授权重庆君子务本科技有限公司及其授权的专业人员对您的影像资料及报告进行解读，
            并将解读结果提供给您。</p>
          <p>请您在确认同意以上内容后，点击“同意”按钮以继续使用“报告解读”服务。如果您不同
            意上述内容，可以选择不使用该服务。</p>
          <div style="height:20px"></div>
        </div>
      </div>
    </van-dialog>
  </div>
</template>
<script>
import { Toast } from 'vant'
import { getSaveInterpretLog } from "@/api/report";
import Storage from "@/tools/storage";
import wx from "weixin-js-sdk";
import axios from "axios";
export default {
  name: "reportResult",
  props: ["listData"],
  data() {
    return {
      checked: true,
      isOpenReadModel: false,
      isOpenReadDetailModel: false,
      exam_id: '',
      xcxurl: ''
    };
  },
  methods: {
    // initSdkConfig() {
    //   axios
    //     .post("https://wechat.pacsonline.cn/wx_patient/api/getJsSdkConfig")
    //     .then(res => {
    //       wx.config({
    //         debug: false,
    //         appId: res.data.appId,
    //         timestamp: res.data.timestamp,
    //         nonceStr: res.data.nonceStr,
    //         signature: res.data.signature,
    //         jsApiList: ['scanQRCode'],
    //         openTagList: ['wx-open-launch-weapp']
    //       });
    //     });
    // },
    getExamStatus(item) {
      switch (item.exam_status) {
        case 1:
          return "已登记";
        case 2:
          return "检查中";
        case 3:
        case 12:
          return "报告中";
        case 7:
          return "报告审核中";
        case 8:
          return "报告已审核";
        case 9:
          return "报告已确认";
      }
      return item.exam_status;
    },
    goReadDetailModel() {
      this.isOpenReadDetailModel = true
    },
    changeHandle(e) {
      console.log(e)
    },
    handleError2(e) {
      this.reportReadRecord(5)
      console.error('跳转失败', e.detail);
    },
    async goDoctorReportRead(item, fromValue) {
      this.exam_id = item.exam_id
      const scene = item.scene || '1'
      this.xcxurl = '/pages/home/index?scene='+ scene +'&exam_id=' + item.exam_id
      this.reportReadRecord(4)

    },
    async reportReadRecord(type) {
      this.isOpenReadModel = true
      let res = await getSaveInterpretLog({
        id: this.exam_id,
        type,
        source: 2
      });
    },
    handleLaunch2(e) {
      this.reportReadRecord(5)
      // const fromValue = Storage.get('fromValue')
      // if(fromValue == 'fromList'){
      //   this.reportReadRecord()
      // }else{
      //   this.reportReadRecord(2)
      // }
      // console.log('跳转成功', e.detail);
    },
    async goReportRead(item, fromValue) {
      if(this.checkReportFn(item)){
        Storage.set("reportSee",item.report_see)
        Storage.set('examStatus',item.exam_status)
        if (item.exam_status == 9||(item.report_see==1&&item.exam_status != 9)) {

          let param = {
            exam_id: item.exam_id,
            institution_id: item.institution_id,
            reportBool: 1
          };
          this.reportReadRecord(item)
          this.$emit("getPatientInfo", param, fromValue);
        } else {
          alert("报告未完成,无法查看报告");
          return;
        }
      }
    },
    // async reportReadRecord(item) {
    //   let res = await getSaveInterpretLog({
    //     id: item.exam_id,
    //     type: 4,
    //     source: 2
    //   });
    // },
    checkReportFn(item) {
      console.log(item);
      // charge_mode 1:向患者收费 2：医院托管 3：医院代收
      // pay_status 0:未支付  1:已支付
      // film_price 价格（不能为0）
      // pay_switch 付费开关 1打开 0关闭
      // if (
      //   item.charge_mode == 1 &&
      //   item.pay_status == 0 &&
      //   item.film_price != 0
      // ) {
      //   alert('未支付数字影像服务费,无法查看报告')
      //   return
      // } else if (
      //   item.charge_mode == 3 &&
      //   item.pay_status == 0 &&
      //   item.film_price != 0
      // ) {
      //   alert('未支付数字影像服务费,请到医院缴费窗口缴费')
      //   return
      // } else {
      //   let params = { exam_id: item.exam_id }
      //   this.$emit('getPatientInfo', params)
      // }
      
      if (item.pay_switch == 1 && item.charge_mode == 3 && item.pay_status == 0) {
        if(item.message){
          alert(item.message);
          return
        }else{
          alert("未支付数字影像服务费,请到医院缴费窗口缴费");
          return
        }
      }
      return true
    },
    checkReport(item, reportBool) {
      if(this.checkReportFn(item)){
        Storage.set("reportSee",item.report_see)
        Storage.set('examStatus',item.exam_status)
        if (item.exam_status == 9||(item.report_see==1&&item.exam_status != 9)) {

          let param = {
            exam_id: item.exam_id,
            institution_id: item.institution_id,
            reportBool
          };
          this.$emit("getPatientInfo", param);
        } else {
          alert("报告未完成,无法查看报告");
          return;
        }
      }
    },
    openEmail(item) {
      if(this.checkReportFn(item)){
        // Toast('邮箱发送维护中...')
        this.$emit('emailShowFn', {'studyId':item.study_id,'value': true})
      }
    },
    pay(item) {
      if (item.charge_mode == 1 && item.pay_status == 0) {
        let params = { id: item.exam_id, openid: Storage.get("openid") };
        this.$emit("getWechatPay", params);
      } else if (item.charge_mode == 3 && item.pay_status == 0) {
        alert("未支付数字影像服务费,请到医院缴费窗口缴费");
      }
    },
    callReportPrint(item) {
      this.$emit("callReportPrint", item);
    }
  },
  created() {
    // this.initSdkConfig()
  },
};
</script>
<style lang="scss" scoped>
.van-checkbox {
  display: inline-block!important;
}
.reportListData {
  width: 100%;
  display: inline-block;
  flex: 1;
  overflow-y: scroll;
  .item {
    height: 170px;
    border-radius: 5px;
    padding: 0 10px;
    box-sizing: border-box;
    background: #ffffff;
    margin-bottom: 20px;
    .item_label {
      height: 30px;
      border-bottom: 1px solid #cccccc;
      display: flex;
      align-items: center;
      color: #51cde4;
      justify-content: space-between;
      font-size: 16px;
      .status {
        font-size: 10px;
        .Danger {
          color: #f56c6c;
        }
      }
    }
    .item_content {
      height: 100px;
      display: flex;
      flex-direction: column;
      div {
        flex: 1;
        display: flex;
        align-items: center;
        font-size: 14px;
        text-align: left;
        .label {
          display: block;
          width: 80px;
          color: #999;
        }
        .content {
          color: #000;
        }
      }
    }
    .item_time {
      height: 30px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      font-size: 12px;
      color: #000000;
      span {
        button {
          color: #ffffff;
          margin-right: 5px;
        }
        .payButton {
          width: 80px;
          padding: 5px 0;
          background-color: #f56c6c;
          border: 1px solid #f56c6c;
          border-radius: 3px;
        }
        .checkButton {
          width: 80px;
          padding: 5px 0;
          background-color: #409eff;
          border: 1px solid #409eff;
          border-radius: 3px;
        }
      }
    }
  }
}
.scrollBox {
  width: 80%;
  /* height: 400px; */
  margin: 0 auto;
  padding: 20px;
  background: #ffffff;
}
.scrollDetailBox {
  width: 80%;
  height: 300px;
  overflow-y: scroll;
  margin: 0 auto;
  padding: 20px;
  background: #ffffff;
}
.blocks::-webkit-scrollbar {
  display: none;
}
.blocks {
  height: 100%;
  border-radius: 10px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  /* padding: 10px; */
}
.blocks div {
  font-size: 14px;
  text-align: center;
  font-weight: bold;
}
.blocks p {
  text-align: left;
  text-indent: 2em;
}
.blocks .subTitle {
  font-weight: bold;
}

.van-button--primary{
  border: 1px solid rgb(19, 172, 193);
  background-color: rgb(19, 172, 193);
}
.van-button__text{
  color: #fff!important;
}
</style>
